export default __webpack_public_path__ + "static/media/loc_reply_type.6167041a.png";